// Third party
import React, { Fragment } from 'react';

// Components
import { ContactInitialsLabel } from '../../../components/misc';
import GenericContact from '@/types/generic-contact';

type Props = {
  contacts: GenericContact[];
  showMax?: number;
};

const ComparisonCardContacts = (props: Props) => {
  const { contacts, showMax } = props;
  const maxItems = showMax || 5;
  const marginItem = 27;

  return (
    <div className="comparison-card-contacts">
      {contacts &&
        contacts.map((contact: GenericContact, index: number) => (
          <Fragment key={`comparison-card-contact${contact._id}`}>
            {index > maxItems ? null : (
              <div className="comparison-card-contacts-contact" style={{ left: `${index > maxItems - 1 ? maxItems * marginItem : index * marginItem}px` }}>
                {index > maxItems - 1 ? (
                  <span className="counter">
                    <span>+</span>
                    {contacts.length - maxItems}
                  </span>
                ) : (
                  <ContactInitialsLabel contact={contact} />
                )}
              </div>
            )}
          </Fragment>
        ))}
    </div>
  );
};

export default ComparisonCardContacts;
